module.exports = __webpack_public_path__ + "img/27000.73129b22.jpg";